import Model from "../model";
import { NormalizedModel } from "../utils/normalized/types";

export const ModelType = "PAYMENT-SOURCE";

export default class PaymentSource extends Model {
  // Attributes
  id: string = "";
  addressZip: string = "";
  brand: string = "";
  country: string = "";
  last4: string = "";
  expMonth: string = "";
  expYear: string = "";
  tokenizationMethod: string = "";
  wallet: string = "";
  type: string = "";

  constructor(attributes: { [key: string]: any }) {
    super();
    this.addAttributes(attributes);
  }

  deserialize(input: NormalizedModel) {
    this.id = input.id;
    this.addAttributes(input.attributes);
  }
}
